import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/element/CategoryTabbedFilter/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/element/LatestBlogsSlider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/element/PromotionSlider/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/section/ServicesCTAAccordion/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Button"] */ "/app/node_modules/@heroui/button/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
